import React from 'react';
import AddSolarUser from '../components/Auth/AddSolarUser';

const AddSolarUserPage: React.FC = () => {
    return (
        <div >
            <AddSolarUser />
        </div>
    );
};

export default AddSolarUserPage;